export default function hardMaxInCapacityRange(value) {
  const maxValue = Math.round(value * 2.5).toPrecision(2);
  return parseFloat(maxValue);
}
